export const tradingSectionClasses = {
  root: 'trading-section',
  body: 'trading-section__body',
  header: 'trading-section__header',
  title: 'trading-section__title',
};
